import React from 'react';

import SimpleField from './simple';

export default function NumericDealField(props) {
  return <SimpleField {...props} type="number" />;
}
